import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {} from 'load-json-file';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Observable } from 'rxjs/Observable';
import { UserGioLocation } from '../../../models/user/usergioLocation';
import { UserLanguageService } from '../../commonservice/commonlangservice.service';
import { CountryService } from '../../commonservice/countrylist.service';
import { geolocation } from '../../commonservice/geolocation/geoloc';
//import { occupationoppservice } from '../../commonservice/occupation/ocupation.service';
import { JsonConfigurationService } from '../../commonservice/readjsonfile';
import { ValidateTMService } from '../../commonservice/TmValidation/tmvalidation.service';
import { utilityService } from '../../commonservice/utility.service';
import { AppSettings } from '../../_common/constants/app.constants';

@Component({
  selector: 'app-splashscreen',
  templateUrl: './splashscreen.component.html',
  styleUrls: ['./splashscreen.component.css'],
  providers: [ValidateTMService, AppSettings, CountryService, UserLanguageService/*, occupationoppservice*/, JsonConfigurationService, geolocation]
})
export class SplashscreenComponent implements OnInit {
  data: any;
  userGioLocation: UserGioLocation;
  constructor(
    public utilityServ: utilityService,
    //private ocupService: occupationoppservice,
    private countryService: CountryService,
    public geoloc: geolocation,
    public translate: TranslateService,
    router: Router
  ) {
    sessionStorage.clear();
    sessionStorage.langCode = 'en';
    // this.geoloc.getGioLocation();
    // TM Profiling
    this.userGioLocation = new UserGioLocation();

    // if (this.getCookie('sessionId') == '' || this.getCookie('sessionId') == undefined) {
    //   sessionStorage.sessionId = this.generateRandomString(20);
    //   this.setCookie('sessionId', sessionStorage.sessionId, 365);
    // }
    // sessionStorage.sessionId = this.getCookie('sessionId');
    if (localStorage.sessionId == undefined || localStorage.sessionId == '') {
      localStorage.sessionId = this.generateRandomString(20);
    }

    // localStorage.sessionId = this.generateRandomString(20);
    const sessionValue: string = localStorage.sessionId;
    // const iFrame: HTMLIFrameElement = document.createElement('iframe');
    // const url: string = AppSettings.tmService + sessionValue;
    // iFrame.src = url;
    // document.body.appendChild(iFrame);
    // iFrame.style.display = 'none';

    // const head = document.getElementsByTagName('head').item(0);
    // const script = document.createElement('script');
    // script.setAttribute('type', 'text/javascript');
    // // generate a new random session_id here to use in matching api call
    // script.setAttribute('src', AppSettings.tmService + sessionValue);
    // head.appendChild(script);

    const enevelop = `{"UpdatedTimeStamp": ""}`;
    // const getBackGroundImage = this.utilityServ.getBackGroundImage(this.getBackGroundImageEnvelope());
    //const getOccupencyList = this.ocupService.getOccupancyList(enevelop);
    const getcountryList = this.countryService.getcountrylist(enevelop);
    const getBeneficiaryRelations = this.utilityServ.restPost(enevelop, AppSettings.ICEMasterService + '/GetBeneficiaryRelations');
    const getTransferReasons = this.utilityServ.restPost(enevelop, AppSettings.ICEMasterService + '/GetTransferReasons');
    // const getCountryDetailList = this.countryService.GetCountryDetailList(enevelop);
    const getCardImage = this.utilityServ.restGet(AppSettings.GetCardImageURL, true);
    const enevelopGetMyIP = `{ "LanguageCode":"${sessionStorage.langCode}"}`;
    const getuserIp = this.utilityServ.restPost(enevelopGetMyIP, AppSettings.GetMyIPService);

    // this.utilityServ.busy = Observable.forkJoin([getBackGroundImage, getcountryList, getCountryDetailList, getuserIp]).subscribe(results => {
    this.utilityServ.busy = Observable.forkJoin([getcountryList, getuserIp]).subscribe(results => {
      // if (results[0] != undefined) {
      //   this.utilityServ.setBackGroundImage(results[0]);
      // }
      if (results[0] != undefined) {
        this.countryService.initialzeCountryList(results[0]);
      }
      // if (results[2] != undefined) {
      //   this.countryService.initialzeCountryDetailList(results[2]);
      // }
      if (results[1] != undefined) {
        sessionStorage.EndUserIP = results[1].IP;
      }
      this.ValidateService();
      router.navigate(['/login']);
    });

    // this.utilityServ.busy = getBackGroundImage.subscribe(results => {
    //   this.utilityServ.setBackGroundImage(results);
    //   this.ValidateService(sessionValue);
    //   router.navigate(['/login']);
    // });

    // this.utilityServ.busy = getcountryList.subscribe(results => {
    //   if (results == undefined) {
    //     return;
    //   }
    //   this.countryService.initialzeCountryList(results);
    // });

    // this.utilityServ.busy = getCountryDetailList.subscribe(results => {
    //   if (results == undefined) {
    //     return;
    //   }
    //   this.countryService.initialzeCountryDetailList(results);
    // });
    getBeneficiaryRelations.subscribe(results => {
      if (results == undefined) {
        return;
      }
      this.utilityServ.setBeneficiaryRelations(results);
    });

    getTransferReasons.subscribe(results => {
      if (results == undefined) {
        return;
      }
      this.utilityServ.setTransferReasons(results);
    });

    getCardImage.subscribe(results => {
      localStorage.CardImages = JSON.stringify(results.Cards);
    });

    // getOccupencyList.subscribe(results => {
    //   this.ocupService.initializeOccupation(results);
    // });
  }

//  old iovation implementation
  ValidateService() {
    // var inputValue = (<HTMLInputElement>document.getElementById('ioBlackBox')).value;
    // sessionStorage.iovationBBKey = inputValue;
  }
  ngOnInit() {}

  getBackGroundImageEnvelope() {
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    const envelope = `{
                        "Latitude":"${this.userGioLocation.longitude}",
                        "Longitude":"${this.userGioLocation.latitude}",
                        "ImageType":"loginbackground",
                        "DeviceType":"web",
                        "UpdatedTimeStamp": ""
                        }`;
    return envelope;  
  }
  generateRandomString(length) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  checkCookie() {
    var user = this.getCookie('username');
    if (user != '') {
      alert('Welcome again ' + user);
    } else {
      user = prompt('Please enter your name:', '');
      if (user != '' && user != null) {
        this.setCookie('username', user, 365);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/splashscreen/splashscreen.component.ts